import React, { useMemo } from "react";

const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;

const HEAD_CX = 12;
const HEAD_CY = 8;
const HEAD_RADIUS = 50;

function wedgePath(cx, cy, radius, startAngle, endAngle) {
  const x1 = cx + radius * Math.cos(startAngle);
  const y1 = cy + radius * Math.sin(startAngle);
  const x2 = cx + radius * Math.cos(endAngle);
  const y2 = cy + radius * Math.sin(endAngle);
  const largeArc = endAngle - startAngle > Math.PI ? 1 : 0;
  return `M ${cx} ${cy} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`;
}

function buildSliceClipPaths(count) {
  if (count <= 0) {
    return [];
  }
  if (count === 1) {
    return ["M 0 0 H 24 V 24 H 0 Z"];
  }
  if (count === 2) {
    return ["M 0 0 H 12 V 24 H 0 Z", "M 12 0 H 24 V 24 H 12 Z"];
  }
  const slices = [];
  const startOffset = -Math.PI / 2;
  for (let i = 0; i < count; i += 1) {
    const start = startOffset + (2 * Math.PI * i) / count;
    const end = startOffset + (2 * Math.PI * (i + 1)) / count;
    slices.push(wedgePath(HEAD_CX, HEAD_CY, HEAD_RADIUS, start, end));
  }
  return slices;
}

export default function MultiTourPin({ colors, size = 30, highlighted = false }) {
  const clipId = useMemo(
    () => `multi-tour-pin-${Math.random().toString(36).slice(2, 9)}`,
    [],
  );
  const slicePaths = useMemo(() => buildSliceClipPaths(colors.length), [colors.length]);

  return (
    <svg
      height={size}
      viewBox="0 0 24 24"
      style={{
        stroke: highlighted ? "#ffffff" : "none",
        strokeWidth: highlighted ? 1.5 : 0,
        filter: highlighted ? "drop-shadow(0 0 4px rgba(255,255,255,0.9))" : undefined,
        display: "block",
      }}
    >
      <defs>
        {slicePaths.map((d, index) => (
          <clipPath key={`${clipId}-${index}`} id={`${clipId}-${index}`}>
            <path d={d} />
          </clipPath>
        ))}
      </defs>
      {colors.map((color, index) => (
        <path
          key={`${clipId}-slice-${index}`}
          d={ICON}
          fill={color}
          clipPath={`url(#${clipId}-${index})`}
        />
      ))}
    </svg>
  );
}
